import { defineStore } from 'pinia';
import { useConfigStore } from './config';
import { IPeriodCtrlConfig } from '@/types/config-type';

export const useTabStore = defineStore({
  id: 'tabStore',
  state: () => ({
    currentTabKey: 'hot',
  }),
  getters: {
    tabConfig() {
      const { couponConfig } = useConfigStore().config as IPeriodCtrlConfig;
      return couponConfig.couponTabConfig
        .map((conf) => ({
          name: conf.tabName,
          key: conf.tabKey,
          tabColor: conf.tabColor,
          tabActiveColor: conf.tabActiveColor,
        }));
    },
    tabTips(state) {
      const { couponConfig } = useConfigStore().config as IPeriodCtrlConfig;
      return couponConfig.couponTabConfig.find((conf) => conf.tabKey === state.currentTabKey)?.tabTips;
    },
  }, // 非必要转换别填
  actions: {
    setCurrentTabKey(key: string) {
      this.currentTabKey = key;
    },
    getTabTips(key: string) {
      const { couponConfig } = useConfigStore().config as IPeriodCtrlConfig;
      return couponConfig.couponTabConfig.find((conf) => conf.tabKey === key)?.tabTips;
    },
  },
});
